import _classCallCheck from "/Users/cheisler/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/cheisler/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * A received message (incoming MESSAGE).
 * @public
 */
export var Message = /*#__PURE__*/function () {
  /** @internal */
  function Message(incomingMessageRequest) {
    _classCallCheck(this, Message);

    this.incomingMessageRequest = incomingMessageRequest;
  }
  /** Incoming MESSAGE request message. */


  _createClass(Message, [{
    key: "accept",

    /** Accept the request. */
    value: function accept(options) {
      this.incomingMessageRequest.accept(options);
      return Promise.resolve();
    }
    /** Reject the request. */

  }, {
    key: "reject",
    value: function reject(options) {
      this.incomingMessageRequest.reject(options);
      return Promise.resolve();
    }
  }, {
    key: "request",
    get: function get() {
      return this.incomingMessageRequest.message;
    }
  }]);

  return Message;
}();